import React from 'react'
import { faStar } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import Icon, { IconNames } from '../icons/icons'
import { INRWorkoutTemplate } from 'interfaces/workout'
import { getWorkoutTemplateDuration } from 'lib/utilities'
import './workout.scss'

interface Props {
  template: INRWorkoutTemplate
  customClick: () => void
  isFavorite?: boolean
}

const WorkoutCard = ({ template, customClick, isFavorite = false }: Props) => {
  const workoutTime = getWorkoutTemplateDuration(template)
  const backgrImg = template.image?.downloadLocation

  return (
    <div className="workoutCard" onClick={customClick}>
      <div className="workoutCard__container">
        <div
          className="workoutCard__header"
          style={backgrImg ? { backgroundImage: `url('${backgrImg}')` } : undefined}
        ></div>
        <div className={`workoutCard__content ${isFavorite ? 'workoutCard__content--favorite' : ''}`}>
          <div className="workoutCard__content__title">{template?.name}</div>
          <div className="workoutCard__content__duration">
            <Icon name={IconNames.CLOCK}></Icon>
            <h5 className="light">{workoutTime}</h5>
          </div>
          {isFavorite && (
            <FontAwesomeIcon
              aria-label="Favorite"
              className="workoutCard__favorite"
              icon={faStar}
              style={{ height: '1.5rem', width: '1.5rem' }}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default WorkoutCard
